import { ProgressBar } from 'primereact/progressbar';
import React from 'react';
import ModalModule from '../modal';

const { Modal } = ModalModule;

const ProcessingPurchaseModal = ({ modalId }) => (
	<Modal
		modalId={modalId}
		className="common-payment processing-purchase-modal"
		header="Processing Purchase"
		hideFooter
	>
		<p>Please wait while your purchase is being processed.</p>
		<ProgressBar mode="indeterminate" />
	</Modal>
);

export default ProcessingPurchaseModal;
